import React from "react";
import { Tabs } from "antd";
import styled from "styled-components";

import CaseQueueConfiguration from "./GlobalConfiguration";

const StyledTabWrapper = styled.div`
  width: 100%;
  max-width: 980px;
  margin: 24px auto;
  @media (max-width: 1200px) {
    max-width: 720px;
  }
  @media (max-width: 788px), (max-width: 922px) {
    max-width: 580px;
  }
  @media (max-width: 720px) {
    max-width: 320px;
  }
`;

const GlobalConfigurations = () => {
  return (
    <StyledTabWrapper>
      <Tabs
        type="card"
        items={[
          {
            key: "case-queue-configuration",
            label: "Case Queue Configuration",
            children: <CaseQueueConfiguration />,
          },
        ]}
      />
    </StyledTabWrapper>
  );
};

export default GlobalConfigurations;
